export default __webpack_public_path__ + "static/media/trees.d55f23a2.svg";